import { useFlags } from "launchdarkly-react-client-sdk";
import { useCallback } from "react";

import { APPOINTMENT_OPPORTUNITY_FIELD } from "constants/feature-flags";
import { resolveIsOpportunity } from "utils/opportunity.util";

type HasRowFlag = { is_opportunity?: boolean } | null | undefined;
type HasTypeFlag = { is_opportunity?: boolean } | null | undefined;

export const useOpportunityFieldEnabled = (): boolean =>
  Boolean(useFlags()[APPOINTMENT_OPPORTUNITY_FIELD]);

/** Curried `resolveIsOpportunity` so a component reads the flag once. */
export const useIsOpportunity = () => {
  const enabled = useOpportunityFieldEnabled();
  return useCallback(
    (appointment: HasRowFlag, appointmentType: HasTypeFlag) =>
      resolveIsOpportunity(appointment, appointmentType, enabled),
    [enabled]
  );
};
